"use client"
import styled from "styled-components";
import {SIZES} from "@/components/constants";
import ContactWrap from "@/app/[locale]/help-center/components/ContactWrap";
import HelpSupportWrap from "@/app/[locale]/help-center/components/HelpSupportWrap";
import React from "react";
import {useSelector} from "react-redux";


const sections = [
    HelpSupportWrap,
    ContactWrap
]


const HelpCenterPage = () => {
    const langData = useSelector(state => state.language.data);
    return(
        <ContactPageWrap>
            <div className={"container"}>
                    {
                        langData &&
                        sections.map((Section, idx) =>
                            <Section key={idx} langData={langData} />
                        )
                    }
            </div>
        </ContactPageWrap>
    )
}
const ContactPageWrap = styled.div`
    padding: 40px 0 60px;
    .container{
        width: 100%;
        margin: 0 auto;
        padding: 0 20px;
        display: flex;
        flex-direction: column;
        gap: 40px;
    }
    @media (min-width: ${SIZES.MOBILE}) {
        .container{
            max-width: 640px;
        }
    }
    @media (min-width: ${SIZES.MOBILE_L}) {
        .container{
            max-width: 768px;

        }
    }
    @media (min-width: ${SIZES.TABLET}) {
        padding: 80px 0 120px;
        .container{
            max-width: 1024px;
            gap: 80px;
        }
    }
    @media (min-width: ${SIZES.TABLET_L}) {
        .container{
            max-width: 1280px;
        }
    }
    @media (min-width: ${SIZES.PC}) {
        .container{
            max-width: 1536px;
        }
    }
`
export default HelpCenterPage